import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { VERSION } from '../version';

function PoliticaPrivacidad() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
    <div className="legal-content" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
      <h1>Política de Privacidad</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Última actualización: 7 de febrero de 2026</p>

      <section style={{ marginBottom: '30px' }}>
        <h2>1. Responsable del tratamiento</h2>
        <p>
          Caja de Lapices, S.L. es responsable del tratamiento de los datos personales recogidos a través de la plataforma CoachFlow CRM.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>2. Datos que recopilamos</h2>
        <p>Podemos recopilar los siguientes tipos de datos personales:</p>
        <ul>
          <li>Datos de identificación: nombre, apellidos, email, teléfono.</li>
          <li>Datos profesionales: empresa, NIF/CIF, dirección.</li>
          <li>Datos de uso: sesiones, reuniones, citas, documentos y notas registradas en la plataforma.</li>
          <li>Datos técnicos: dirección IP, tipo de navegador, datos de acceso.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>3. Finalidad del tratamiento</h2>
        <p>Los datos personales se tratan con las siguientes finalidades:</p>
        <ul>
          <li>Prestación del servicio de gestión CRM.</li>
          <li>Gestión de la relación contractual.</li>
          <li>Facturación y administración.</li>
          <li>Mejora del servicio y soporte técnico.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>4. Base legal del tratamiento</h2>
        <p>
          El tratamiento de datos se basa en el consentimiento del usuario, la ejecución de un contrato 
          y el cumplimiento de obligaciones legales aplicables.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>5. Conservación de datos</h2>
        <p>
          Los datos personales se conservarán mientras sea necesario para cumplir con la finalidad para 
          la que fueron recogidos y para cumplir con las obligaciones legales aplicables.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>6. Derechos del usuario</h2>
        <p>El usuario tiene derecho a:</p>
        <ul>
          <li>Acceder a sus datos personales.</li>
          <li>Rectificar datos inexactos o incompletos.</li>
          <li>Solicitar la supresión de sus datos.</li>
          <li>Oponerse al tratamiento de sus datos.</li>
          <li>Solicitar la portabilidad de sus datos.</li>
          <li>Revocar el consentimiento otorgado.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>7. Seguridad de los datos</h2>
        <p>
          Implementamos medidas técnicas y organizativas apropiadas para proteger los datos personales 
          contra el acceso no autorizado, la alteración, la divulgación o la destrucción.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>8. Transferencias internacionales</h2>
        <p>
          Los datos se almacenan en servidores ubicados en la Unión Europea. En caso de transferencias 
          internacionales, se garantizará un nivel adecuado de protección conforme al RGPD.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>9. Contacto</h2>
        <p>
          Para cualquier consulta relacionada con esta política de privacidad, puede contactarnos a través 
          de los canales habilitados en la plataforma.
        </p>
      </section>

      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee', textAlign: 'center' }}>
        <Link to="/" style={{ color: '#007bff', textDecoration: 'none' }}>← Volver al inicio</Link>
        <span style={{ margin: '0 15px', color: '#ccc' }}>|</span>
        <Link to="/terminos" style={{ color: '#007bff', textDecoration: 'none' }}>Términos y Condiciones</Link>
      </div>

    </div>
    <footer className="app-footer">
      <p>
        &copy; 2025-26 Caja de Lapices, S.L. All rights reserved. | Made with Love in Spain | v{VERSION}
        <span className="footer-links">
          {' | '}<Link to="/privacidad" style={{ color: 'inherit', opacity: 0.8 }}>Política de Privacidad</Link>
          {' | '}<Link to="/terminos" style={{ color: 'inherit', opacity: 0.8 }}>Términos y Condiciones</Link>
        </span>
      </p>
    </footer>
    </>
  );
}

export default PoliticaPrivacidad;
